import "./Header.scss";
import ButtonOutline from "./ButtonOutline";

import HeaderLogo from "../../assets/images/header-logo.svg";
import React from "react";
import { ReactComponent as Download } from "../../assets/icons/download.svg";

export default function Header() {
	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior

		try {
			const target = e.target.getAttribute("href");
			const targetElement = document.querySelector(target);
			const headerHeight = document.querySelector(".header").offsetHeight;

			const yOffset = -headerHeight; // Negative offset to account for the header
			const yPosition =
				targetElement.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo({ top: yPosition, behavior: "smooth" });
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="header">
			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					<a
						href="/"
						className="header-logo-link"
					>
						<img
							className="header-logo"
							src={HeaderLogo}
							alt="Header Logo"
							width="60"
							height="37"
						/>
					</a>
				</div>

				<div className="header-center">
					<nav className="header-nav">
						<ul className="header-nav-list">
							<li>
								<a href="#features" onClick={handleScroll}>
									Features
								</a>
							</li>
							<li>
								<a href="#roadmap" onClick={handleScroll}>
									Roadmap
								</a>
							</li>
							<li>
								<a href="#footer" onClick={handleScroll}>
									Community
								</a>
							</li>
						</ul>
					</nav>
				</div>

				<div className="header-right">
					<ButtonOutline className="download-app-btn">
						<Download className="btn-icon" width={19} height={19} />
						Download App
					</ButtonOutline>
				</div>
			</div>
		</div>
	);
}
